import { Component, Input } from '@angular/core';

@Component({
  selector: 'success-badge-light',
  templateUrl: './success-badge-light.component.html',
  standalone: false,
})
export class SuccessBadgeLightComponent {
  @Input() label: string;
  @Input() tooltip: string;
}
